module.exports = __webpack_public_path__ + "img/u22.63238108.png";